"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxRightSide/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _NoChat = require('./NoChat'); var _NoChat2 = _interopRequireDefault(_NoChat);
var _NewChat = require('web/screens/CreateNew/NewChat'); var _NewChat2 = _interopRequireDefault(_NewChat);
var _Chat = require('./Chat'); var _Chat2 = _interopRequireDefault(_Chat);
















const InboxRightSide = ({
  blobjectKey,
  createdChatType,
  isNewChatOpen = !!createdChatType,
  isDraftOpen = false,
  newChatRun = 0,
  gotoConversation,
  onCloseCreateNewChat,
  onCreatedChat,
  onDraftChange,
}) => (
  _react2.default.createElement(_react2.default.Fragment, null
    /* The open chat stays mounted under New chat (and its draft), so
        closing it comes back to the same scroll position and draft. */
    ,  blobjectKey
      ? _react2.default.createElement(_Chat2.default, { blobjectKey: blobjectKey, isHidden: isDraftOpen, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}} )
      : !isDraftOpen && _react2.default.createElement(_NoChat2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 42}} ) 
    ,  createdChatType && (
      _react2.default.createElement(_NewChat2.default, {
        key: newChatRun,
        chatType: createdChatType,
        isVisible: isNewChatOpen,
        gotoConversation: gotoConversation,
        onCloseCreateNewChat: onCloseCreateNewChat,
        onFinished: onCreatedChat,
        onDraftChange: onDraftChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
      )
    )
  )
)

exports. default = InboxRightSide
